import { ThemeConfigureService } from '../shared/services/theme-configure-service/theme-configure-service';
import { UserService } from '../shared/services/user-services/user.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { ViewProfileService } from '../shared/services/view-profile-servies/view-profile.service';
import { ConfiguratorService } from '../shared/services/configurator-service/configurator.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SidebarService } from '../shared/services/sidebar.service';
import { Router } from '@angular/router';
import { SuperAdminProxyService } from '../shared/services/super-admin-proxy.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  // styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  currentUser: any = '';
  currentUserId: any;
  userId: any = '65e723b88756162399ed5b85';
  defaultImage: any = '../../assets/image/adminlogo.png';
  showProfileDropdown = false;

  imageUrl: string | null = null;
  userRole: any;
  headerLogo: string | undefined = '../../assets/image/logo.png';
  orgLogo: string | undefined = '../../assets/image/logo_invotron.png';

  orgName = "SigmaTConFlux™";
  /** Cached org initials for the avatar fallback (e.g. "GI" for Greenleaf Infra). */
  orgInitials = 'OR';
imageBaseUrl = environment.imageBaseUrl;
  currentLang: string;
  /** Super Admin org proxy banner (only while proxying) */
  showProxyBanner = false;
  proxyOrgName = '';
  /** JWT/role: Super Admin — UI label */
  isSuperAdmin = false;
  /** JWT `type === 1` — only this account can use org proxy (matches API) */
  canUseOrgProxy = false;
  /** True while session has a proxy org (same as banner visibility) */
  isOrgProxyActive = false;

  constructor(
    private readonly userService: UserService,
    private translate: TranslateService,
    private sidebarService: SidebarService, 
private router:Router,
    private readonly superAdminProxy: SuperAdminProxyService
  ) { 

    // this.translate.setDefaultLang('en');  // en | hi | mr | te | ml | tm
    const savedLang = localStorage.getItem('appLanguage') || 'en';
  this.translate.setDefaultLang(savedLang);
  this.translate.use(savedLang);
   this.currentLang = savedLang;
  }

  ngOnInit(): void {
    const userDetails = this.userService.getUserDetailsFromSession();
    this.currentUser = userDetails.user.full_name ?? userDetails.user.org_name;

    // Only build a logo URL when the org actually has one uploaded. Otherwise
    // the template renders the initials avatar (no broken-image icon).
    const orgLogoPath = userDetails?.user?.org_logo;
    this.imageUrl = orgLogoPath ? `${this.imageBaseUrl}${orgLogoPath}` : null;

    const sessionOrgName = userDetails?.user?.org_name;
    if (sessionOrgName) this.orgName = sessionOrgName;
    this.orgInitials = this.computeOrgInitials(this.orgName);

    this.orgLogo = this.orgLogo;
    this.userRole = this.userService.getUserRole();

    try {
      const raw = localStorage.getItem('user');
      if (raw) {
        const p = JSON.parse(raw);
        const u = p?.user || p;
        this.isSuperAdmin =
          u?.type === 1 ||
          u?.role_id === 1 ||
          u?.role_name === 'Admin' ||
          u?.role_name === 'Super Admin';
      }
    } catch {
      this.isSuperAdmin = false;
    }

    this.canUseOrgProxy = this.superAdminProxy.canUseOrgProxy();
    this.isOrgProxyActive = this.superAdminProxy.isProxying();
    this.showProxyBanner = this.canUseOrgProxy && this.isOrgProxyActive;
    this.proxyOrgName = this.superAdminProxy.getProxyOrgName();
  }

  exitOrganizationProxy(): void {
    this.superAdminProxy.clearProxy();
    window.location.reload();
  }
  switchLanguage(event: Event): void {
    const selectedLang = (event.target as HTMLSelectElement).value;
    this.translate.use(selectedLang);
    localStorage.setItem('appLanguage', selectedLang);
  }

  toggleMobileSidebar(): void {
    this.sidebarService.toggleSidebar();
  }
  logout(){
    this.userService.logout();
    this.router.navigate(['/']);
  }

  toggleProfileDropdown(): void {
    this.showProfileDropdown = !this.showProfileDropdown;
  }

  navigateToPurchasePlan(): void {
    this.router.navigate(['/plan']);
  }

  /**
   * Drop the broken image and fall back to initials. Bound to <img (error)>
   * so a stale/404 logo URL flips us back into the avatar branch.
   */
  onLogoError(): void {
    this.imageUrl = null;
  }

  /**
   * Build a 1–2 character avatar label from the org name. Strips non-letters
   * and uses the first letter of the first two words, falling back to the
   * first two letters of a single word or a safe default.
   */
  private computeOrgInitials(name: string | null | undefined): string {
    if (!name) return 'OR';
    const cleaned = name.replace(/[^\p{L}\p{N}\s]/gu, ' ').trim();
    if (!cleaned) return 'OR';
    const words = cleaned.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return words[0].slice(0, 2).toUpperCase();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.profile-dropdown-container')) {
      this.showProfileDropdown = false;
    }
  }
}
